(function () {
  'use strict';
  angular.module('vcdms.vcdoctype')
    .component('doctypesearch', {
      restrict: 'E',
      bindings: {
        doctype: '<',
        doctyperef: '<',
        parentsave: '&?',
        editinplace: '@?',
        ti: '@?'
      },
      template: `
        <div class="form-group">
          <div class="input-group">
                <input type="text" class="form-control" tabindex="{{vm.tabi}}"
                   ng-class="{'dirtyfield': vm.asyncSelected.length > 0}"
                   placeholder="Kürzel"
                   ng-model="vm.asyncSelected"
                   typeahead-on-select="$parent.$dismiss();vm.showdoctype($item, $model, $label)"
                   uib-typeahead="doctype as doctype.text for doctype in vm.getDoctypes($viewValue)"
                   typeahead-loading="loadingNames"
                   typeahead-no-results="noResults">
            <span class="input-group-btn">
              <button type="submit"
                      ng-class="{'btn-warning': noResults, 'btn-info': !noResults}"
                      class="btn" tabindex="-1"><i class="fa fa-search"></i></button>
            </span>
          </div>
        </div>
        
        
        <i ng-show="loadingNames" class="fa fa-refresh"></i>
        <div ng-show="noResults">
          <i class="fa fa-remove"></i> Keine SV gefunden
          <span class="btn btn-success" ng-click="vm.addDoctype()" ng-hide="vm.error">Neue Sozialversicherung eingeben</span>
          <span ng-click="vm.addDoctype()" ng-show="vm.error"><i class="fa fa-warning text-danger"></i> Sozialversicherung konnte nicht angelegt werden!</span>
        </div>
        
        <div ng-show="vm.editinplace === true">
          <doctypeeditor doctype="vm.doctype"></doctypeeditor>
        </div>
        
        
      `,
      controllerAs: 'vm',
      controller: ['$log', 'Doctype', 'DoctypeHelper',
        function ($log, Doctype, DoctypeHelper) {
          let vm = this;
          vm.save = save;
          vm.showdoctype = showdoctype;

          vm.getDoctypes = getDoctypes;
          // vm.addDoctype = DoctypeHelper.addDoctype;
          vm.addDoctype = addDoctype;
          vm.editDoctype = DoctypeHelper.editDoctype;

          vm.$onInit = function () {
            vm.newdoctype = {};

            if (angular.isDefined(vm.editinplace) && vm.editinplace === 'true') {
              vm.editinplace = true;
            }

            $log.debug('debug - editinplace', vm.editinplace);


            if (angular.isUndefined(vm.ti)) {
              vm.ti = 0;
              vm.tabi = 0;
            }
            if (angular.isString(vm.ti)) {
              vm.tabi = parseInt(vm.ti, 10);
            }
            else {
              vm.tabi = 0;
            }
            vm.lastdoctype = angular.copy(vm.doctyperesult);
            vm.lastdoctyperef = angular.copy(vm.doctyperef);
          };

          function addDoctype() {
            $log.debug('debug - doctypesearch addDoctype called');
            DoctypeHelper.addDoctype(function (doctype) {
              $log.debug('debug: handle newly create doctype');
              vm.doctype = {};
              vm.doctype.name = doctype.name;
              vm.doctype.short = doctype.short;
              vm.doctype._id = doctype._id;
              vm.doctyperef = doctype._id;
              vm.asyncSelected = doctype.short;
              vm.parentsave({doctype: vm.doctype, doctyperef: vm.doctyperef});
            }, function (err) {
              vm.error = true;
              $log.error(err);
            });
          }


          // typeahead doctype search backend query
          function getDoctypes(val) {
            // return Doctypeahead.$search({query: val}).$asPromise().then(function (response) {
            return Doctype.$searchahead({query: val}).$asPromise().then(function (response) {
              return response.map(function (doctype) {
                doctype.text = doctype.short;
                delete vm.error;
                return doctype;
              });
            });
          }

          // typeahead doctype search action
          function showdoctype($item, $model, $label) {
            /* eslint "no-unused-vars": [0, {"args": "none"}] */
            vm.doctype = $model;
            vm.doctyperef = $model._id;
            delete vm.asyncSelected;
            vm.editinplace = true;
            $log.debug('debug - vm.editinplace, vm.editinplace === true?: ', vm.editinplace, vm.editinplace === true);
            if (vm.editinplace === true) {
              vm.doctype = $model;
              vm.doctyperef = $model._id;
              $log.debug('debug - doctypesearch editinplace');
            }
            else {
              vm.doctype = {};
              vm.doctype.name = $model.name;
              vm.doctype.short = $model.short;
              vm.doctype._id = $model._id;
              vm.doctyperef = $model._id;
              vm.parentsave({doctype: vm.doctype, doctyperef: vm.doctyperef});
              $log.debug('debug - doctypesearch do not  editinplace', vm.parentsave);
            }
          }

          function save() {
            if (!angular.equals(vm.doctype, vm.lastdoctype) || !angular.equals(vm.doctyperef, vm.lastdoctyperef)) {
              vm.lastdoctype = angular.copy(vm.doctype);
              vm.lastdoctyperef = angular.copy(vm.doctyperef);
              vm.parentsave({doctype: vm.doctype, doctyperef: vm.doctyperef});
            }
          }

        }] // controller
    }); // component

// klammerfriedhof
}());
